import { Button, ButtonGroup, Chip, Tooltip, Typography } from "@mui/material";
import { NavLink } from "react-router-dom";
import { useEffect, useState } from "react";
import { Image, Popconfirm } from "antd";
import { toast } from "react-toastify";
import Datatable from "../../../Comp/Table/Datatable";
import useAxiosPrivate from "../../../Hooks/useAxiosPrivate";
import useStore from "../../../Hooks/useStore";

const AnnouncementTable = ({ setSearchTerm, categories, tableData = [], loading = false, page, setPage, rowsPerPage, setRowsPerPage, totalCount = 0 }) => {
  const axiosPrivate = useAxiosPrivate();
  const { setFetchAgain } = useStore();

  const TOGGLE_ANNOUNCEMENT_URL = "/api/deals/toggleAnnouncement";

  const handleStatus = async (data) => {
    try {
      const response = await axiosPrivate.post(TOGGLE_ANNOUNCEMENT_URL, {
        id: data._id,

      });

      toast.success(response.data.message);
      setFetchAgain((prev) => !prev);
    } catch (error) {
      toast.error(error.response.data.message);
      console.log(error);
    }
  };

  const columns = [
    {
      name: "_id",
      label: "Action",
      options: {
        customBodyRender: (id) => {
          const fullRowData = (tableData || []).find((data) => data._id === id);
          return (
            <ButtonGroup orientation="vertical" variant="text" color="primary">
              <NavLink to="/createannoucement" state={{ fullRowData }}>
                <Button>Edit</Button>
              </NavLink>
            </ButtonGroup>
          );
        },
      },
    },
    {
      name: "group_id_arr",
      label: "Groups",
      options: {
        customBodyRender: (categoryIds) => {
          const getLabel = (id) => {
            const match = categories.find((cat) => cat.value === id);
            return match ? match.label : id;
          };

          const labels = (categoryIds || []).map(getLabel);

          return (
            <Tooltip
              title={
                <div>
                  {labels.map((label, i) => (
                    <Chip key={i} label={label} size="small" sx={{ margin: "2px" }} />
                  ))}
                </div>
              }
            >
              <Typography
                sx={{
                  width: "120px",
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                }}
              >
                {labels.map((label, i) => (
                  <Chip
                    key={i}
                    label={label}
                    size="small"
                    variant="outlined"
                    sx={{ marginRight: "2px" }}
                  />
                ))}
              </Typography>
            </Tooltip>
          );
        },
      },
    },
    {
      name: "url",
      label: "URL",
    },
    {
      name: "message",
      label: "Message",
      options: {
        customBodyRender: (text) => (
          <Tooltip title={text}>
            <Typography
              sx={{
                width: "200px",
                overflow: "hidden",
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
              }}
            >
              {text}
            </Typography>
          </Tooltip>
        ),
      },
    },
    {
      name: "img_url",
      label: "Image",
      options: {
        customBodyRender: (img_url) => (
          <Image
            src={img_url}
            alt="img"
            width={40}
            height={40}
            style={{ objectFit: "cover", borderRadius: 4 }}
            placeholder={
              <Image
                preview={false}
                src="https://via.placeholder.com/40"
                width={40}
                height={40}
              />
            }
          />
        ),
      },
    },
    {
      name: "active",
      label: "Status",
      options: {
        customBodyRender: (active, tableMeta) => {
          var data = {};
          data._id = tableMeta.rowData[0];
          data.active = active ? false : true;
          if (active)
            return (
              <Popconfirm
                placement="topRight"
                title="Deactivate Announcement"
                description="Do you really want to deactivate the announcement?"
                okText="Yes"
                cancelText="No"
                onConfirm={() => handleStatus(data)}
              >
                <Button color="error" size="small" variant="outlined">
                  <b>Deactivate</b>
                </Button>
              </Popconfirm>
            );
          else
            return (
              <Popconfirm
                placement="topRight"
                title="Activate Announcement"
                description="Do you really want to activate the announcement?"
                okText="Yes"
                cancelText="No"
                onConfirm={() => handleStatus(data)}
              >
                <Button color="success" size="small" variant="outlined">
                  <b>Activate</b>
                </Button>
              </Popconfirm>
            );
        },
        filter: true,
        sort: true,
      },
    },
  ];

  return (
    <Datatable
      name="Deal Announcements"
      columns={columns}
      data={tableData}
      loading={loading}
      setSearchTerm={setSearchTerm}
      totalCount={totalCount}
      setPage={setPage}
      page={page}
      rowsPerPage={rowsPerPage}
      setRowsPerPage={setRowsPerPage}
      searchPlaceholder="Search by  Message"
    />
  );
};

export default AnnouncementTable;
